'use strict';

exports.__esModule = true;
exports.default = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _windowScroller = require('../window-scroller');

var _windowScroller2 = _interopRequireDefault(_windowScroller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var outerBaseClassName = 'csp-header__outer-container';
//much longer poll rate for IE
var getPollRate = function getPollRate() {
  return window && window.navigator.userAgent.indexOf('Trident') > 0 ? 200 : 30;
};

var StickyHeader = function (_React$Component) {
  _inherits(StickyHeader, _React$Component);

  function StickyHeader() {
    var _temp, _this, _ret;

    _classCallCheck(this, StickyHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      scrollingDown: null,
      scrollAtTop: false,
      headerScrollTop: null,
      headerHeight: 0
    }, _this.handleScroll = function (e, scrollTop) {
      _this.setState({ headerScrollTop: scrollTop });
    }, _this.handleResize = function (e) {
      if (_this.headerElement.offsetHeight !== _this.state.headerHeight) {
        _this.setState({ headerHeight: _this.headerElement.offsetHeight }, function () {
          _this.props.setHeaderState(_this.state.headerHeight, !_this.state.scrollingDown);
        });
      }
    }, _this.handleDirection = function (down) {
      if (_this.state.scrollingDown !== down) {
        _this.setState({
          scrollingDown: down
        }, function () {
          _this.props.setHeaderState(_this.state.headerHeight, !_this.state.scrollingDown);
        });
      }
    }, _this.getOuterBaseClassName = function () {
      return outerBaseClassName + ' ' + (_this.props.hasSecondaryMenu && outerBaseClassName + '--has-sub-menu');
    }, _this.handleAtTop = function () {
      _this.headerContainer.className = _this.getOuterBaseClassName() + ' ' + outerBaseClassName + '--no-scroll';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StickyHeader.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.setState({ headerHeight: this.headerElement.offsetHeight });
  };

  StickyHeader.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    if (this.headerElement.offsetHeight !== this.state.headerHeight) {
      this.setState({ headerHeight: this.headerElement.offsetHeight }, function () {
        _this2.props.setHeaderState(_this2.state.headerHeight, !_this2.state.scrollingDown);
      });
    }
  };

  StickyHeader.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };

  StickyHeader.prototype.getScrollClass = function getScrollClass() {
    var scrollingDown = this.state.scrollingDown;

    if (scrollingDown === null || this.headerElement && this.state.headerScrollTop < this.headerElement.offsetHeight) {
      //retain up scrolling styles while we're inside the header region
      if (!scrollingDown) {
        return outerBaseClassName + '--no-scroll ' + outerBaseClassName + '--scroll-up';
      }

      return outerBaseClassName + '--no-scroll';
    }

    if (scrollingDown) {
      return outerBaseClassName + '--scroll-down';
    } else {
      //set parent height to match target
      return outerBaseClassName + '--scroll-up';
    }
  };

  StickyHeader.prototype.render = function render() {
    var _this3 = this;

    var outerClassName = this.getOuterBaseClassName() + ' ' + this.getScrollClass();
    return _react2.default.createElement(
      _windowScroller2.default,
      {
        onScroll: this.handleScroll,
        getDirection: this.handleDirection,
        pageTopCallback: this.handleAtTop,
        pollRate: getPollRate()
      },
      _react2.default.createElement(
        'div',
        {
          className: outerClassName,
          ref: function ref(div) {
            _this3.headerContainer = div;
          }
        },
        _react2.default.createElement(
          'header',
          {
            className: 'csp-header',
            ref: function ref(header) {
              _this3.headerElement = header;
            }
          },
          this.props.children
        )
      )
    );
  };

  return StickyHeader;
}(_react2.default.Component);

exports.default = StickyHeader;


StickyHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  getDirection: _propTypes2.default.func,
  onScroll: _propTypes2.default.func,
  pageTopCallback: _propTypes2.default.func,
  setHeaderState: _propTypes2.default.func,
  children: _propTypes2.default.node,
  hasSecondaryMenu: _propTypes2.default.bool
} : {};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/sticky-header/StickyHeader.js
// module id = 1407
// module chunks = 249